import { useState } from "react";
import AppointmentForm from "../../form/AppointmentForm";

const SpecFaq = ({ heading, imageUrl, faqs = [], slug }) => {

  const [showModal, setShowModal] = useState(false);

  const openModal = () => setShowModal(true);
  const closeModal = () => setShowModal(false);

  if (!faqs.length) return null;

  return (
    <>
      <section className="spec-faq-section py-5 mt-lg-5 mt-0">
        <div className="container">
          <div className="row align-items-center">
            {imageUrl && (
              <div className="col-lg-5 mb-0 spec-faq-sticky d-none d-lg-block">
                <div className="specFaqImgWrapper" data-sal="slide-right" data-sal-duration="300" data-sal-delay="100">
                  <img src={`${process.env.REACT_APP_WEB_URL}/${imageUrl}`} alt="FAQ Illustration" className="img-fluid" />
                </div>
              </div>
            )}

            <div className={imageUrl ? "col-lg-7" : "col-lg-12"}>
              <div className="row mb-4">
                <div className="col-12">
                  <h2
                    className="section-title text-center text-md-start text-capitalize"
                    data-sal="slide-up"
                    data-sal-duration="300"
                    data-sal-delay="100"
                    dangerouslySetInnerHTML={{ __html: heading || "Understanding Gastrointestinal Disorders – Causes & Risks Explained!" }}
                  />
                  {imageUrl && (
                    <div className="col-12 my-4 d-block d-lg-none">
                      <div className="specFaqImgWrapper" data-sal="slide-right" data-sal-duration="300" data-sal-delay="100">
                        <img src={`${process.env.REACT_APP_WEB_URL}/${imageUrl}`} alt="FAQ Illustration" className="img-fluid" />
                      </div>
                    </div>
                  )}
                </div>
              </div>

              <div className="accordion accordion-flush" id="SpecFaqAccordion">
                {faqs.map((faq, index) => (
                  <div
                    className="accordion-item"
                    key={index}
                    data-sal="slide-up"
                    data-sal-duration="300"
                    data-sal-delay={(index + 1) * 20}
                  >
                    <h2 className="accordion-header">
                      <button
                        className={`accordion-button ${index !== 0 ? "collapsed" : ""}`}
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target={`#flush-collapse${index}`}
                        aria-expanded={index === 0}
                        aria-controls={`flush-collapse${index}`}
                      >
                        {faq.question}
                      </button>
                    </h2>
                    <div
                      id={`flush-collapse${index}`}
                      className={`accordion-collapse collapse ${index === 0 ? "show" : ""}`}
                      data-bs-parent="#SpecFaqAccordion"
                    >
                      <div className="accordion-body px-0">
                        <div
                          className="footer-description"
                          data-sal="slide-up"
                          data-sal-duration="300"
                          dangerouslySetInnerHTML={{ __html: faq.answer }}
                        />
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              <div className="row pt-5">
                <div className="col-12">
                  <button
                    type="button"
                    className="about-btn"
                    data-sal="slide-up"
                    data-sal-duration="1000"
                    data-sal-delay="100"
                    onClick={openModal}
                  >
                    Book an Appointment
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <AppointmentForm
        show={showModal}
        handleClose={closeModal}
        doctorName={slug}
      />
    </>
  );
};

export default SpecFaq;
